import { render, staticRenderFns } from "./folders-files.vue?vue&type=template&id=2c27745f"
import script from "./folders-files.vue?vue&type=script&lang=js"
export * from "./folders-files.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports